import {
  Button,
  Col,
  Form,
  Checkbox,
  Input,
  Row,
  message,
  Table,
  Select,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import PatientService from "../../../Services/PatientService";
import DoctorService from "../../../Services/DoctorService";
const { Option } = Select;

function AddReferral(props) {
  const [filteredPatient, setFilteredPatient] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [doctorSpecialties, setDoctorSpecialties] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [chronicData, setChronicData] = useState([]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [form] = useForm();

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const columns = [
    {
      title: "",
      dataIndex: "patientId",
      render: (patientId, record) => (
        <Checkbox
          checked={selectedPatient && selectedPatient.patientId === patientId}
          onChange={() => handleRadioChange(record)}
        />
      ),
    },
    {
      title: "Patient ID",
      dataIndex: "patientId",
    },
    {
      title: "Name",
      dataIndex: "firstName",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },
  ];

  const handleCancel = () => {
    form.resetFields();
    props.onCancel();
  };

  const handleSearch = async () => {
    if (!mobileNumber || mobileNumber.length < 10) {
      return message.error("Please enter a valid mobile number.");
    }

    const payload = {
      mobile: isNaN(mobileNumber) ? null : mobileNumber,
    };

    try {
      const result = await PatientService.PatientListFilter(payload);
      setFilteredPatient(result.data);
      setIsVisible(true);
    } catch (error) {
      message.error("Error fetching patient list");
    }
  };

  const cancelFilter = () => {
    setIsVisible(false);
    setMobileNumber("");
    setSelectedPatient(null);
  };

  const handleRadioChange = (record) => {
    setSelectedPatient(record || null);
  };

  const addReferalSave = async () => {
    try {
      await form.validateFields();
      const payload = form.getFieldValue();
      payload.patientId = selectedPatient?.patientId;
      payload.createdBy = loginResultObject.user.userId;
      payload.referBy = loginResultObject.user.userId;
      payload.modifiedBy = loginResultObject.user.userId;
      payload.status = 1;
      payload.referType = "D";
      payload.hyperLinkUrl = "";
      payload.referByAccount_Id = loginResultObject.user.account_Id;
      payload.referByClinic_Id = loginResultObject.user.clinic_Id;

      const result = await DoctorService.referToSave(payload);
      if (result.data.data === 1) {
        message.success("Referral Added Successfully");
        form.resetFields();
        props.onCancel();
      } else {
        message.error("Failed to Add Referral");
      }
    } catch (error) {
      message.error("Please fill out all required fields correctly.");
    }
  };

  const getChronicData = async () => {
    try {
      const response = await DoctorService.chronicList({ status: 1 });
      setChronicData(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleMobileNumberChange = (event) => {
    setMobileNumber(event.target.value);
  };

  const getClinicListDoctors = async () => {
    try {
      const response = await DoctorService.getDoctors({
        // account_Id: loginResultObject.user.account_Id,
        status: 1,
      });
      setDoctors(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setSelectedPatient(null);
    setFilteredPatient([]);
    setMobileNumber("");
    form.resetFields();
    getChronicData();
    getClinicListDoctors();
    getSpecialities();
    setDoctorSpecialties([]);
  }, []);

  useEffect(() => {
    form.setFieldValue(
      "patientName",
      selectedPatient
        ? `${selectedPatient.firstName} ${selectedPatient.lastName}`
        : ""
    );
  }, [selectedPatient]);

  const handleSpecialityChange = async (code) => {
    if (code) {
      const payload = {
        specialityCode: code,
        // account_Id: loginResultObject.user.account_Id,
        status: 1,
      };
      const response = await DoctorService.getDoctors(payload);
      setDoctors(response.data);
    }
  };

  const getSpecialities = async (data = {}) => {
    let payload = {
      ...data,
      status: 1,
    };
    try {
      const response = await DoctorService.getDoctorSpeciality(payload);
      if (response) {
        setDoctorSpecialties(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleDoctorChange = (value) => {
    let data = {
      userId: value,
    };
    getSpecialities(data);
  };

  return (
    <div>
      <div className="flex gap-2 mt-4">
        <Input
          placeholder="Enter patient mobile number"
          name="mobile"
          value={mobileNumber}
          onChange={handleMobileNumberChange}
          onKeyDown={(e) => {
            const allowedKeys = [
              "0",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "Backspace",
              "Delete",
              "ArrowLeft",
              "ArrowRight",
              "Tab",
            ];
            if (!allowedKeys.includes(e.key)) e.preventDefault();
          }}
        />
        <button
          className="h-8 text-white rounded-md px-10"
          type="primary"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>

      {isVisible && (
        <div className="mt-2">
          <Table
            columns={columns}
            dataSource={filteredPatient}
            pagination={{ pageSize: 3 }}
            scroll={{ x: "max-content", y: false }}
            onRow={(record) => ({
              onClick: () => handleRadioChange(record),
            })}
            className="cursor-pointer"
          />
          <div className="w-full flex justify-end gap-2">
            <button
              className="p-2 rounded-md border border-[#189FAA] w-24 bg-white text-black"
              onClick={cancelFilter}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      <Form
        className="formDesign"
        name="referToForm"
        layout="vertical"
        form={form}
        onFinish={addReferalSave}
      >
        <Row gutter={20} className="mt-5">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              label="Patient Name"
              name="patientName"
              rules={[{ required: true, message: "Patient Name is required" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              label="Speciality"
              name="speciality"
              rules={[{ required: true, message: "Doctor is required" }]}
            >
              <Select
                className="w-[20%] rounded-lg cursor-pointer bg-white"
                placeholder="Speciality"
                allowClear
                showSearch
                onChange={handleSpecialityChange}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={doctorSpecialties?.map((spec) => {
                  return {
                    label: spec.speciality,
                    value: spec.code,
                  };
                })}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              label="Doctor"
              name="referTo"
              rules={[{ required: true, message: "Doctor is required" }]}
            >
              <Select
                className="w-full"
                placeholder="Select Doctor"
                onChange={handleDoctorChange}
              >
                {doctors
                  .filter(
                    (doctor) => doctor.userId !== loginResultObject.user.userId
                  )
                  .map((doctor) => (
                    <Option key={doctor.userId} value={doctor.userId}>
                      {`${doctor.firstName} ${doctor.lastName}`}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              label="Condition"
              name="chronicCode"
              rules={[{ required: true, message: "Condition is required" }]}
            >
              <Select className="w-full" placeholder="Select Condition">
                {chronicData.map((chronic) => (
                  <Option key={chronic.code} value={chronic.code}>
                    {chronic.description}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={3} className="w-full" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <div className="flex justify-end gap-3 pt-2">
            <Button className="md:h-9 Btnwhite md:px-8" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className="md:h-9 md:px-10"
              type="primary"
              htmlType="submit"
            >
              Add
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

export default AddReferral;
